<script>
  import { mapState } from 'vuex';
  import { validateAmount } from 'utils/validator';
  import {
    addAffHedgeApp,
    affPaymentAutoPayProcess,
    auditAffHedgeAppStatus,
    getAffHedgeAppPreviewData,
  } from 'api/affSendingBilling/application/affHedgeApplication';
  import { financeInfoMixins } from '@/mixins/financeInfoMixins';

  const defaultFomrData = {
    affHedgeAppNumber: null,
    recordDateRange: [],
    affCompanyPlatform: null,
    affEntity: null,
    hyperTapEntity: null,
    affHedgeAmount: null,
    paymentStatus: null,
    remark: null,
    currency: 'CNY',
    affRevenue: null,
    auditRemark: null,
    affConfirmedAmount: null,
  };

  const defaultPreviewData = {
    totalAffConfirmedAmount: null,
    totalAffCoverAmount: null,
    totalAffConversion: null,
    totalAffDeductionAmount: null,
    totalAffRevenue: null,
  };

  export default {
    name: 'BillingOperationBaseForm',
    mixins: [financeInfoMixins],
    props: {
      dialogType: {
        type: String,
        default: 'new',
      },
      auditStatus: {
        type: String,
        default: '',
      },
      commonCompanyEntityList: {
        type: Array,
        default: () => {
          return [];
        },
      },
      dialogVisible: {
        type: Boolean,
        default: false,
      },
      editData: {
        type: Object,
        default: () => {
          return {};
        },
      },
    },
    data() {
      return {
        formData: Object.assign({}, defaultFomrData),
        previewData: Object.assign({}, defaultPreviewData),
        previewWatchField: {
          recordDateRange: [],
          affCompanyPlatform: null,
          affEntity: null,
        },
        rules: {
          affHedgeAmount: [{ validator: validateAmount, trigger: 'blur', required: true }],
          affCompanyPlatform: [{ required: true, trigger: 'blur' }],
          affEntity: [{ required: true, trigger: 'blur' }],
          recordDateRange: [{ required: true, trigger: 'blur' }],
          hyperTapEntity: [{ required: true, trigger: 'blur' }],
          paymentStatus: [{ required: true, trigger: 'blur' }],
          currency: [{ required: true, trigger: 'blur' }],
          affHedgeAppNumber: [{ required: true, trigger: 'blur' }],
          remark: [],
        },
        formProcessing: false,
      };
    },
    computed: {
      ...mapState({
        hyperTapEntityList: (state) => state['enum'].billingEnum.hyperTapEntityList,
        affHedgeAppPaymentStatusList: (state) =>
          state['enum'].billingEnum.affHedgeAppPaymentStatusList,
        currencyList: (state) => state['enum'].billingEnum.currencyList,
      }),
    },
    watch: {
      formData: {
        immediate: true,
        handler(val) {
          const { recordDateRange, affCompanyPlatform, affEntity } = val;
          // 值是否发生变化
          if (
            this.previewWatchField.affEntity === affEntity &&
            this.previewWatchField.affCompanyPlatform === affCompanyPlatform &&
            this.previewWatchField.recordDateRange.join(',') === recordDateRange.join(',')
          ) {
            return;
          }

          if (recordDateRange && recordDateRange.length > 0 && affCompanyPlatform && affEntity) {
            setTimeout(() => {
              if (
                recordDateRange &&
                recordDateRange.length > 0 &&
                affCompanyPlatform &&
                affEntity
              ) {
                this.handlePreview();
                this.previewWatchField = {
                  recordDateRange,
                  affCompanyPlatform,
                  affEntity,
                };
              }
            }, 500);
          }
        },
        deep: true,
      },
    },
    methods: {
      handleFormProcessingEnd() {
        setTimeout(() => {
          this.formProcessing = false;
        }, 500);
      },
      handleSubmit() {
        this.$refs.baseForm.validate((valid) => {
          if (valid) {
            this.formProcessing = true;
            switch (this.dialogType) {
              case 'new':
                addAffHedgeApp({ ...this.formData })
                  .then(() => {
                    this.$message({
                      message: 'Add Success',
                      type: 'success',
                    });
                    this.$emit('refresh-list');
                    this.handleClose();
                  })
                  .finally(() => {
                    this.handleFormProcessingEnd();
                  });
                break;
              case 'edit':
                break;
              case 'status':
                if (this.auditStatus === 'AUTO_PAYMENT') {
                  affPaymentAutoPayProcess(this.formData.affHedgeAppNumber)
                    .then(() => {
                      this.$message({
                        message: 'Success',
                        type: 'success',
                      });
                      this.$emit('refresh-list');
                      this.handleClose();
                    })
                    .finally(() => {
                      this.handleFormProcessingEnd();
                    });
                } else {
                  auditAffHedgeAppStatus({
                    affHedgeAppNumber: this.formData.affHedgeAppNumber,
                    auditRemark: this.formData.auditRemark,
                    auditStatus: this.auditStatus,
                  })
                    .then(() => {
                      this.$message({
                        message: 'Success',
                        type: 'success',
                      });
                      this.$emit('refresh-list');
                      this.handleClose();
                    })
                    .finally(() => {
                      this.handleFormProcessingEnd();
                    });
                }
                break;
            }
          } else {
            return false;
          }
        });
      },
      handleClose() {
        this.$emit('update:dialogVisible', false);
        this.$emit('update:auditStatus', null);
        this.$refs.baseForm.resetFields();
        this.formData = Object.assign({}, defaultFomrData);
        this.previewData = Object.assign({}, defaultPreviewData);
        this.previewWatchField = {
          recordDateRange: [],
          affCompanyPlatform: null,
          affEntity: null,
        };
      },
      handlePreview() {
        if (
          this.formData.recordDateRange.length === 0 ||
          !this.formData.affCompanyPlatform ||
          !this.formData.affEntity
        ) {
          this.$message.error('请填写日期、公司平台、公司实体');
          return;
        }
        this.formProcessing = true;
        getAffHedgeAppPreviewData({
          recordDateRange: this.formData.recordDateRange,
          affCompanyPlatform: this.formData.affCompanyPlatform,
          affEntity: this.formData.affEntity,
        })
          .then((res) => {
            if (res && res.result) {
              this.previewData = res.result;
            }
          })
          .finally(() => {
            setTimeout(() => {
              this.formProcessing = false;
            }, 500);
          });
      },
    },
  };
</script>

<template>
  <el-dialog
    :title="dialogType === 'new' ? 'Aff Hedge Application Create' : 'Aff Hedge Application Update'"
    :visible="dialogVisible"
    :close-on-click-modal="false"
    width="40%"
    @close="handleClose"
  >
    <el-form
      label-position="left"
      label-width="200px"
      ref="baseForm"
      :model="formData"
      :rules="rules"
      :disabled="formProcessing"
    >
      <section v-if="dialogType === 'status'" class="grid-form-large">
        <el-form-item label="Aff Hedge App Number" prop="affHedgeAppNumber" required>
          <el-input v-model="formData.affHedgeAppNumber" placeholder="please input" />
        </el-form-item>
        <el-form-item
          label="Audit Remark "
          v-if="auditStatus !== 'AUTO_PAYMENT'"
          prop="auditRemark"
        >
          <el-input
            v-model="formData.auditRemark"
            type="textarea"
            show-word-limit
            maxlength="255"
            label-width="240px"
            placeholder="please input"
          />
        </el-form-item>
      </section>

      <section v-if="dialogType === 'auto-payment'" class="grid-form-large">
        <el-form-item label="Aff Hedge App Number" prop="affHedgeAppNumber" required>
          <el-input v-model="formData.affHedgeAppNumber" placeholder="please input" />
        </el-form-item>
      </section>

      <section v-if="dialogType === 'new'" class="grid-form">
        <el-form-item label="Date" prop="recordDateRange">
          <el-date-picker
            v-model="formData.recordDateRange"
            format="yyyy-MM"
            value-format="yyyy-MM"
            type="monthrange"
            clearable
            align="right"
            unlink-panels
            style="width: 250px"
            range-separator="to"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          />
        </el-form-item>
        <el-form-item label="Aff Company Platform" prop="affCompanyPlatform" required>
          <el-select
            v-model="formData.affCompanyPlatform"
            filterable
            clearable
            @change="handleCompanyPlatformChange(formData.affCompanyPlatform)"
          >
            <el-option
              v-for="item in companyPlatformList"
              :key="item"
              :label="item"
              :value="item"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="Aff Entity" prop="affEntity" required>
          <el-select v-model="formData.affEntity" ref="companyEntityOptions" filterable clearable>
            <el-option
              v-for="item in specificCompanyEntity"
              :key="item.id"
              :label="item.companyEntity"
              :value="item.companyEntity"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="HyperTap Entity" prop="hyperTapEntity" required>
          <el-select v-model="formData.hyperTapEntity" filterable placeholder="please select">
            <el-option
              v-for="item in hyperTapCompanyEntities"
              :key="item.bfiId"
              :label="item.companyEntityAlias"
              :value="item.companyEntity"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="Currency" prop="currency" required>
          <el-select v-model="formData.currency" filterable placeholder="please select">
            <el-option
              v-for="item in currencyList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="Aff Conversion">
          <el-input v-model="previewData.totalAffConversion" disabled />
        </el-form-item>
        <el-form-item label="Aff Revenue">
          <el-input v-model="previewData.totalAffRevenue" disabled />
        </el-form-item>
        <el-form-item label="Aff Deduction Amount">
          <el-input v-model="previewData.totalAffDeductionAmount" disabled />
        </el-form-item>
        <el-form-item label="Aff Cover Amount">
          <el-input v-model="previewData.totalAffCoverAmount" disabled />
        </el-form-item>
        <el-form-item label="Aff Confirmed Amount">
          <el-input v-model="previewData.totalAffConfirmedAmount" disabled />
        </el-form-item>
        <el-form-item label="Hedge Amount" prop="affHedgeAmount" required>
          <el-input type="number" v-model="formData.affHedgeAmount" />
        </el-form-item>
        <el-form-item label="Payment Status" prop="paymentStatus" required>
          <el-select v-model="formData.paymentStatus" filterable placeholder="please select">
            <el-option
              v-for="item in affHedgeAppPaymentStatusList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="Remark" prop="remark">
          <el-input
            v-model="formData.remark"
            type="textarea"
            show-word-limit
            maxlength="255"
            placeholder="please input"
          />
        </el-form-item>
      </section>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" :loading="formProcessing" @click="handleSubmit">确 定</el-button>
    </span>
  </el-dialog>
</template>

<style scoped lang="scss"></style>
